import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  useGridApiRef,
  GridBooleanCell,
} from '@mui/x-data-grid-premium';
import { Box, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { dataGridPremiumColumns } from '../../utils/helper';
import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { useState } from 'react';
import { EmployeeAttendanceSimpleMode } from '../../utils/employeeAttendance';
import dayjs from 'dayjs';
import EmployeeAttendanceMyReportsAttachments from './EmployeeAttendanceMyReportsAttachments';
import useParam from '../../context/ParamContext';

const EmployeeAttendanceMyReportsTable = ({ myReports }) => {
  const { params } = useParam();
  const apiRef = useGridApiRef();
  const [attachDialogData, setAttachDialogData] = useState({ open: false, attachments: [] });

  const contractorsManagementEnabled = params.EMPLOYEE_ATTENDANCE_CONTRACTORS_MANAGEMENT === 'Y';

  const columns = dataGridPremiumColumns([
    {
      field: 'attendanceDate',
      headerName: 'Dátum',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.employeeAttendance.date);
      },
      renderCell: (data) => {
        return dayjs(data.row.employeeAttendance.date).format('YYYY.MM.DD');
      },
    },
    {
      field: 'attendanceProjectId',
      headerName: 'Projekt',
      type: 'string',
      renderCell: (data) => {
        return data.row.employeeAttendance.project?.projectName;
      },
    },
    {
      field: 'employeeId',
      headerName: 'Dolgozó',
      type: 'string',
      renderCell: (data) => {
        return data.row.employee?.name;
      },
    },
    ...(contractorsManagementEnabled
      ? [
          {
            field: 'companyId',
            headerName: 'Alvállalkozó',
            type: 'string',
            renderCell: (data) => {
              return data.row.company?.name;
            },
          },
          {
            field: 'headCount',
            headerName: 'Létszám',
            type: 'number',
          },
        ]
      : []),
    {
      field: 'fromTime',
      headerName: 'Kezdő időpont',
      type: 'time',
      valueGetter: (_data, row) => {
        return row.fromTime ? new Date(row.fromTime) : null;
      },
      renderCell: (data) => {
        return dayjs.utc(data.row.fromTime).format('HH:mm');
      },
    },
    {
      field: 'toTime',
      headerName: 'Befejező időpont',
      type: 'time',
      valueGetter: (_data, row) => {
        return row.toTime ? new Date(row.toTime) : null;
      },
      renderCell: (data) => {
        return dayjs.utc(data.row.toTime).format('HH:mm');
      },
    },
    {
      field: 'attendanceDescription',
      headerName: 'Fej megjegyzés',
      type: 'string',
      renderCell: (data) => {
        return data.row.employeeAttendance.description;
      },
    },
    {
      field: 'description',
      headerName: 'Tétel megjegyzés',
      type: 'string',
      renderCell: (data) => {
        return data.row.description;
      },
    },
    {
      field: 'employeeAttendanceAttachment',
      headerName: 'Csatolmányok',
      type: 'string',
      renderCell: (data) => {
        return (
          <ButtonUI
            size="sm"
            className="bg-success px-2.5 py-1"
            onClick={() => {
              setAttachDialogData({
                open: true,
                attachments: data.row.employeeAttendance.employeeAttendanceAttachment,
              });
            }}
            text={
              <Box display="flex">
                <AttachFileIcon fontSize="small" />
                <Typography fontSize="medium">
                  {data.row.employeeAttendance.employeeAttendanceAttachment.length}
                </Typography>
              </Box>
            }
          />
        );
      },
    },
    ...(params.SHOW_EMPLOYEE_ATTENDANCE_SIMPLETASK_FIELD === 'Y'
      ? [
          {
            field: 'attendanceSimpleTaskId',
            headerName: 'Feladat',
            type: 'string',
            renderCell: (data) => {
              return data.row.employeeAttendance.simpleTask?.simpleTaskName;
            },
          },
        ]
      : []),
  ]);

  return (
    <>
      <div className="overflow-x-auto">
        <div className="align-middle">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <DatagridPremiumUi
              apiRef={apiRef}
              datagridIdentifier={DataGridIdentifiers.EmployeeAttendanceMyReportsTable}
              height={460}
              columns={columns}
              rows={myReports}
              headerFilters={false}
              slots={{
                toolbar: null,
              }}
              getRowHeight={() => 'auto'}
            />
          </div>
        </div>
      </div>

      <EmployeeAttendanceMyReportsAttachments
        dialogData={attachDialogData}
        handleClose={() => setAttachDialogData({ open: false, attachments: [] })}
      />
    </>
  );
};

export default EmployeeAttendanceMyReportsTable;
